import Image from "next/image";
import slugify from "slugify";
import type { Article } from "../../../BlogTypes";

interface NewBlogCardProps {
    title?: string;
    category: string;
    subcategory: string;
    img: string;
    slug: string;
    categorySlug?: string;
    subcategorySlug?: string;
    blog: Article;
}

export default function NewBlogCard({
    title,
    category,
    subcategory,
    img,
    slug,
    categorySlug,
    subcategorySlug,
    blog,
}: NewBlogCardProps) {
    const href = `/de/${slugify(category, { lower: true })}/${slugify(subcategory, {
        lower: true,
    })}/${slug}`;
    return (
        <>
            <div className="lg:w-[910px]  lg:h-40 w-83 h-76 px-3 py-5 shadow border-b border-zinc-300 justify-start items-center gap-3 lg:inline-flex">
                <a href={href}>
                    <Image
                        className="lg:w-55 lg:h-34 w-89 h-40 rounded border border-zinc-300"
                        src={img}
                        alt=""
                        width={1200}
                        height={1200}
                    />
                </a>
                <div className="grow shrink basis-0 flex-col justify-start items-start inline-flex">
                    <a href={href}>
                        <div className="text-neutral-800 text-2xl lg:text-xl3 font-bold leading-7 lg:leading-10 line-clamp-2">
                            {title}
                        </div>
                    </a>
                    <div className="self-stretch justify-start items-center gap-1 inline-flex">
                        <a
                            href={
                                blog
                                    ? `/de/category/${blog.category_slug}/${blog.subcategories_slug[0]}`
                                    : `/de/category/${categorySlug}/${subcategorySlug}`
                            }
                        >
                            <div className="text-center text-black text-base lg:text-[22px] font-normal underline leading-tight lg:leading-8.5">
                                {category} / {subcategory}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}
